import { render, staticRenderFns } from "./tour-selector.vue?vue&type=template&id=12cb7572&scoped=true&"
import script from "./tour-selector.vue?vue&type=script&lang=js&"
export * from "./tour-selector.vue?vue&type=script&lang=js&"
import style0 from "./tour-selector.vue?vue&type=style&index=0&id=12cb7572&prod&lang=scss&"
import style1 from "./tour-selector.vue?vue&type=style&index=1&id=12cb7572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb7572",
  null
  
)

export default component.exports